var MySettingsDataEditDrawer = (function ($) {

    MySettingsDataEditDrawer = function (options) {
        var that = this;

        // CONST
        that.selectors = {
            input_part_name: '.js-input-part-name',
            input_birthday: '.js-input-birthday',
            button_confirm: '.js-submit'
        };
        that.class = {
            consistent_name: 'js-consistent-name'
        };
        /**
         * @type {PhotoUploaderControl|{}}
         */
        that.photo_uploader_control = options['photo_uploader_control'] || {};

        // DOM
        that.$wrapper = options['$wrapper'];
        that.$form = that.$wrapper.find('form');
        that.$input_part_name = that.$wrapper.find(that.selectors.input_part_name);
        that.$input_birthday = that.$wrapper.find(that.selectors.input_birthday);
        that.$submit_button = that.$wrapper.find(that.selectors.button_confirm);

        // INIT
        that.init();
    };

    MySettingsDataEditDrawer.prototype.init = function () {
        var that = this;

        //
        that.__initInputs();
        //
        that.__initSubmit();
        //
        that.__initPhotoUploaderControl();
    };

    // Init Methods

    MySettingsDataEditDrawer.prototype.__initInputs = function () {
        var that = this;

        that.__initInputNameMask();
        //
        that.__initInputBirthdayMask();
    };

    MySettingsDataEditDrawer.prototype.__initInputNameMask = function () {
        var that = this;

        that.$input_part_name.each(function () {
            var $input = $(this),
                input_type = $input.data('type'),
                value = $input.val();

            UIInputMask.prototype.initNameInputMask($input, input_type);
            $input.val(value);
            UIInput.prototype.setNotEmpty($input, !!value);

            $input.on('input', function () {
                that.__validateNameField($(this));
                that.__toggleButtonAvailability(that.__isValid());
            });

            $input.on('blur', function () {
                that.__validateNameField($(this));
                that.__toggleButtonAvailability(that.__isValid());
            });
        });
    };
    MySettingsDataEditDrawer.prototype.__initInputBirthdayMask = function () {
        var that = this;

        UIInput.prototype.setNotEmpty(that.$input_birthday, !!that.$input_birthday.val());
        UIInputMask.prototype.initBirthdayMask(that.$input_birthday);

        that.$input_birthday.on('blur', function () {
            if (!that.__isValidBirthday()) {
                UIInput.prototype.setError(that.$input_birthday);
                that.__toggleButtonAvailability(false);
            } else {
                that.__toggleButtonAvailability(true);
            }
        });
    };

    /**
     * Если изменилась фото, то установим в drawer колбек, перезагружающий контент при закрытии
     *
     * @private
     */
    MySettingsDataEditDrawer.prototype.__initPhotoUploaderControl = function () {
        var that = this;
        that.photo_uploader_control.onChange = function () {
            that.$wrapper.data('drawer').onClose = function () {
                $.sa.content_router.reload();
                return true
            }
        }
    }

    // Validators

    MySettingsDataEditDrawer.prototype.__isValid = function () {
        var that = this;

        return that.__isValidNameWithoutEmptyFields() && 
            that.__isValidNameFieldsSumLength() &&
            that.__isValidNameCharset() &&
            that.__isValidBirthday();
    };

    MySettingsDataEditDrawer.prototype.__validateNameField = function ($input) {
        var that = this,
            error_empty_text = $input.data('error-empty'),
            error_limit_characters_text = $input.data('limit-characters'),
            error_charset_text = $input.data('error-charset');

        if ($input.val().length > 0) {
            if (!that.__isValidNameFieldsSumLength()) {
                UIInput.prototype.setError($input, error_limit_characters_text, true);
            } else if (!that.__isValidNameCharset()) {
                if ($input.hasClass(that.class.consistent_name)) {
                    UIInput.prototype.setError($input, error_charset_text, true);
                }
            } else {
                that.$input_part_name.each(function () {
                    UIInput.prototype.clearError($(this));
                });
            }
        } else if (!that.__isValidNameWithoutEmptyFields()) {
            UIInput.prototype.setError($input, error_empty_text, true);
        }
    };
    
    MySettingsDataEditDrawer.prototype.__isValidNameWithoutEmptyFields = function () {
        return UIInputMask.prototype.validateNameEmptyFields(this.$wrapper);
    };

    MySettingsDataEditDrawer.prototype.__isValidNameFieldsSumLength = function () {
        return UIInputMask.prototype.validateNameFieldsLength(this.$wrapper);
    };

    MySettingsDataEditDrawer.prototype.__isValidNameCharset = function () {
        return UIInputMask.prototype.validateNameCharset(this.$wrapper);
    };

    MySettingsDataEditDrawer.prototype.__isValidBirthday = function () {
        return UIInputMask.prototype.validateBirthday(this.$input_birthday.val().trim(), true);
    };

    // Helpers

    MySettingsDataEditDrawer.prototype.__toggleButtonAvailability = function (is_available) {
        var that = this;

        that.$submit_button.prop('disabled', !is_available);
    };

    // Saver

    MySettingsDataEditDrawer.prototype.__initSubmit = function () {
        var that = this,
            is_locked = false;

        that.$form.on('submit', function (e) {
            e.preventDefault();
            if (is_locked) {
                return;
            }
            is_locked = true;

            if (!that.__isValid()) {
                return;
            }
            $.sa.buttonLoading(that.$submit_button, true);

            var href = $.sa.build_url('my/settings/data-save'),
                data = that.$form.serializeArray();

            $.post(href, data, function (res) {
                var res_is_string = typeof res === 'string';
                if (!res || res_is_string) {
                    res = {
                        status: 'fail',
                        errors: [
                            {
                                code: 0,
                                message: res_is_string ? res : $.sa.locales['something_went_wrong'],
                            }
                        ],
                    };
                }

                switch (res.status) {
                    case 'ok':
                        that.__handleSuccess(res);
                        break;
                    case 'fail':
                        that.__handleError(res);
                        break;
                }

                is_locked = false;
                $.sa.buttonLoading(that.$submit_button, false);
            });

        });
    }

    MySettingsDataEditDrawer.prototype.__handleSuccess = function (res) {
        var that = this;

        // Set new name in header
        $('.js-firstname').text(res.data.raw.firstname);
        // Set new name in chat for Smart Up users
        var $user_name = $('.js-user-name');
        if ($user_name.length && typeof $user_name.attr('data-user-name') !== 'undefined') {
            $user_name.data('user-name', res.data['formatted']['name']);
        }

        // Если у drawer и есть колбек, то он не нужен — вызовем перезагрузку контента самостоятельно
        that.$wrapper.data('drawer').onClose = function () {};
        that.$wrapper.data('drawer').close();
        // Reload content
        $.sa.content_router.reload();
    };

    MySettingsDataEditDrawer.prototype.__handleError = function (res) {
        var that = this,
            errors = res.errors || [];

        $.each(errors, function (i, error) {
            if (error.message) {
                $.sa.notifier.show({
                    title: error.message,
                    notifier_class: $.sa.notifier.class.error
                });
            } else {
                for (input_name in error) {
                    var $input = that.$wrapper.find('[name="data[' + input_name + ']"]');
                    if ($input.length) {
                        UIInput.prototype.setError($input);
                    }
                }
            }
        });
    };

    return MySettingsDataEditDrawer;
})(jQuery);
